export const DEFAULT_LICENCES_STATE = {
  loading: false,
  licences: [],
};
